import { render, staticRenderFns } from "./TeacherDetail.vue?vue&type=template&id=3b2079a8"
import script from "./TeacherDetail.vue?vue&type=script&lang=js"
export * from "./TeacherDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports